import * as SDISVC from '../SDIService';
import SDIConstants from '../SDIConstants';
import { Dispatcher } from 'simplr-flux';
import * as CookieService from '../CookieService';
import * as $ from 'jquery';
import * as MenuAction from '../actions/MenuAction';

const tokenExpired = async () => {
    try {
        let tokenExpiredData = { type: "Token_Expired", response: true };
        Dispatcher.dispatch(tokenExpiredData);

    } catch (ex) {
        console.log(ex)

    }
};
const ReconPageLoad = (ReconPageLoadBO) => {
    try {
       
        SDISVC.callSecureGateway(
            SDIConstants.moduleNames.ReconCycle,
            SDIConstants.methodNames.ReconPage_Load,
            JSON.stringify(ReconPageLoadBO),
            (data) => {
                if (data.success) {

                    if (data.response != "" && data.response) {
                        let contentData = { type: "Reconpageload", response: data.response };
                        Dispatcher.dispatch(contentData);
                    }
                }
                else if (data.success == false) {
                    if (data.response) {
                        if (data.response == SDIConstants.tokenExpired) {
                            tokenExpired();
                        }
                    }
                }
            });
    } catch (ex) {
        console.log(ex)
    }
}

const ReconGridLoad = (ReconGridLoadBO) => {
    try {
        
        SDISVC.callSecureGateway(
            SDIConstants.moduleNames.ReconCycle,
            SDIConstants.methodNames.ReconGrid_Load,
            JSON.stringify(ReconGridLoadBO),
            (data) => {
                if (data.success) {
                   
                    if (data.response != "" && data.response) {
                        let contentData = { type: "Recongridload", response: data.response };
                        Dispatcher.dispatch(contentData);
                    }
                }
                else if (data.success == false) {
                    if (data.response) {
                        if (data.response == SDIConstants.tokenExpired) {
                            tokenExpired();
                        }
                    }
                }
            });
    } catch (ex) {
        console.log(ex)
    }
}

const ReconUpdateQty = (ReconUpdateBO) => {
    try {
        
        SDISVC.callSecureGateway(
            SDIConstants.moduleNames.ReconCycle,
            SDIConstants.methodNames.Update_Click,
            JSON.stringify(ReconUpdateBO),
            (data) => {
                if (data.success) {
                   
                    if (data.response != "" && data.response) {
                        let contentData = { type: "Reconupdate", response: data.response };
                        Dispatcher.dispatch(contentData);
                    }
                }
                else if (data.success == false) {
                    if (data.response) {
                        if (data.response == SDIConstants.tokenExpired) {
                            tokenExpired();
                        }
                    }
                }
            });
    } catch (ex) {
        console.log(ex)
    }
}
const ExportData = (excelbo) => {
    try {

        SDISVC.downloadFile(
            SDIConstants.moduleNames.ReconCycle,
            SDIConstants.methodNames.ExportToExcel,
            JSON.stringify(excelbo),
            "Reconciliation.xlsx",
            (data) => {
                if (data.success) {
                    if (data.response != "" && data.response) {
                        
                        $(`#${SDIConstants.SDILoader}`).addClass('hide');
                        let contentData = { type: "Export", response: data.response };
                        Dispatcher.dispatch(contentData);
                    }
                }
            });
    } catch (ex) {
        console.log(ex)
    }
}
const ReconSearch = (searchBO) => {
    try {
        
        SDISVC.callSecureGateway(
            SDIConstants.moduleNames.ReconCycle,
            SDIConstants.methodNames.GetSearchRecon,
            JSON.stringify(searchBO),
            (data) => {
                if (data.success) {
                    
                    if (data.response != "" && data.response) {
                        let contentData = { type: "ReconSearch", response: data.response };
                        Dispatcher.dispatch(contentData);
                    }
                }
                else if (data.success == false) {
                    if (data.response) {
                        if (data.response == SDIConstants.tokenExpired) {
                            tokenExpired();
                        }
                    }
                }
            });
    } catch (ex) {
        console.log(ex)
    }
}

const FinalRecon = (finalBO) => {
    try {

        SDISVC.callSecureGateway(
            SDIConstants.moduleNames.ReconCycle,
            SDIConstants.methodNames.FinalizeRecon,
            JSON.stringify(finalBO),
            (data) => {
                if (data.success) {
                   
                    if (data.response != "" && data.response) {
                        let contentData = { type: "ReconFinalz", response: data.response };
                        Dispatcher.dispatch(contentData);
                    }
                }
                else if (data.success == false) {
                    if (data.response) {
                        if (data.response == SDIConstants.tokenExpired) {
                            tokenExpired();
                        }
                    }
                }
            });
    } catch (ex) {
        console.log(ex)
    }
}

const insertFavPage = async (insertFavPageBO) => {
    try {
        SDISVC.callSecureGateway(
            SDIConstants.moduleNames.Menu,
            SDIConstants.methodNames.Menu_InsertFavPage,
            JSON.stringify(insertFavPageBO),
            (data) => {
                if (data.success) {
                    if (data.response != "" && data.response) {
                        let contentData = { type: "ORDERSTS_InsertFavPage", response: data.response };
                        Dispatcher.dispatch(contentData);
                    }
                } else if (data.success == false) {
                    if (data.response) {
                        if (data.response == SDIConstants.tokenExpired) {
                            MenuAction.tokenExpired();
                        }
                    }
                }
            });

    } catch (ex) {
        console.log(ex)
    }
};

const deleteFavPage = async (deleteFavPageBO) => {
    try {
        SDISVC.callSecureGateway(
            SDIConstants.moduleNames.Menu,
            SDIConstants.methodNames.Menu_DeleteFavPage,
            JSON.stringify(deleteFavPageBO),
            (data) => {
                if (data.success) {
                    if (data.response != "" && data.response) {
                        let contentData = { type: "ORDERSTS_DeleteFavPage", response: data.response };
                        Dispatcher.dispatch(contentData);
                    }
                } else if (data.success == false) {
                    if (data.response) {
                        if (data.response == SDIConstants.tokenExpired) {
                            MenuAction.tokenExpired();
                        }
                    }
                }
            });

    } catch (ex) {
        console.log(ex)
    }
};

const getCurrentFavPage = async (getFavPageBO) => {
    try {
        SDISVC.callRecurringGateway(
            SDIConstants.moduleNames.Menu,
            SDIConstants.methodNames.Menu_GetCurrentFavPage,
            JSON.stringify(getFavPageBO),
            (data) => {
                if (data.success) {
                    if (data.response != "" && data.response) {
                        let contentData = { type: "ORDERSTS_CurrentFavPage", response: data.response };
                        Dispatcher.dispatch(contentData);
                    }
                } else if (data.success == false) {
                    if (data.response) {
                        if (data.response == SDIConstants.tokenExpired) {
                            MenuAction.tokenExpired();
                        }
                    }
                }
            });

    } catch (ex) {
        console.log(ex)
    }
}

const LoadRecon = (loadBO) => {
    try {
      
        SDISVC.callSecureGateway(
            SDIConstants.moduleNames.ReconCycle,
            SDIConstants.methodNames.LoadRecon,
            JSON.stringify(loadBO),
            (data) => {
                if (data.success) {
                   
                    if (data.response != "" && data.response) {
                        let contentData = { type: "ReconLoad", response: data.response };
                        Dispatcher.dispatch(contentData);
                    }
                }
                else if (data.success == false) {
                    if (data.response) {
                        if (data.response == SDIConstants.tokenExpired) {
                            tokenExpired();
                        }
                    }
                }
            });
    } catch (ex) {
        console.log(ex)
    }
}


export { ReconPageLoad, ReconUpdateQty, ExportData, ReconSearch, FinalRecon, LoadRecon, ReconGridLoad, insertFavPage, deleteFavPage, getCurrentFavPage }